var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolitician1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -51.2,
    y: -51.2,
    width: 614.4,
    height: 614.4,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 214.349,
    cy: 41.647,
    r: 41.647
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.473,155.195c-5.856-9.426-18.244-12.32-27.674-6.466l-52.666,32.719l-0.189-37.563 c-0.131-26.09-21.464-47.315-47.554-47.315h-19.77c-3.764,9.761-22.024,57.117-25.786,66.876l6.03-28.405 c0.417-1.966,0.115-4.017-0.854-5.778l-8.17-14.859l7.249-13.184c1.081-1.964-0.343-4.378-2.589-4.378h-19.916 c-2.243,0-3.671,2.41-2.589,4.378l7.264,13.211l-8.185,14.886c-0.951,1.727-1.26,3.735-0.876,5.67l5.224,28.457 c-2.816-7.302-22.28-59.933-24.957-66.876H160.3c-26.091,0-47.423,21.226-47.554,47.315l-0.248,49.271l40.19,0.142l0.247-49.213 c0.011-2.198,1.799-3.972,3.996-3.967c2.198,0.006,3.977,1.789,3.977,3.987v49.193c10.315,0,96.125,0,106.439,0v-49.245 c0-2.322,1.882-4.205,4.205-4.205c2.323,0,4.205,1.883,4.205,4.205c0,0.011,0,0.022,0,0.033l0.247,49.212h22.201 c15.431,0,27.986,12.554,27.986,27.986v1.23l63.82-39.647C399.436,177.012,402.33,164.621,396.473,155.195z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.203,215.56H128.597c-3.157,0-5.726,2.569-5.726,5.725v90.208c0,3.157,2.569,5.726,5.726,5.726h21.595V276.9 c0-16.433,13.37-29.803,29.803-29.803h69.094c16.433,0,29.803,13.37,29.803,29.803v40.318h19.31c3.157,0,5.726-2.569,5.726-5.726 v-90.208C303.928,218.129,301.359,215.56,298.203,215.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.528,481.888h-25.896V276.898c0-4.165-3.377-7.542-7.542-7.542h-69.094c-4.165,0-7.542,3.377-7.542,7.542v204.989 h-25.896c-4.165,0-7.542,3.377-7.542,7.542v15.028c0,4.165,3.377,7.542,7.542,7.542h135.97c4.165,0,7.542-3.377,7.542-7.542 V489.43C290.07,485.265,286.694,481.888,282.528,481.888z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitician1);
export default __webpack_public_path__ + "static/media/politician1.c73713b84b42524a7513b70bd1d8e2af.svg";
export { ForwardRef as ReactComponent };